export default "__VITE_ASSET__BTaFXUJ1__"